
<template>
  <img src="/Images/user-trans100x100.gif" v-bind:style="getStyle()" />
</template>

<script>

	export default {
    name: 'common-round-image',
		components: {
    },
    data() {
      return {

      }
    },
    props: [
      'borderwidth',
      'bordercolor'
    ],
    methods: {
      getStyle() {
        var bcolor = "red";
        var bwidth = "4px";
        if (typeof this.bordercolor != "undefined")
          bcolor = this.bordercolor;
        if (typeof this.borderwidth != "undefined")
          bwidth = this.borderwidth;
        return "border: " + bwidth + " solid " + bcolor + "; background-color: " + bcolor + ";";
      }
    },
    created() {
      
    },
    mounted() {

    }
}
</script>
<style  scoped>
  img {
    border-radius: 50%;
    box-shadow: inset 0 0 0 5px white;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/common-round-image.vue